import React, { useState } from 'react'
import { createStyles, makeStyles, Theme, createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
import { Table, TableBody, TableContainer, Paper, Typography, Box, Grid, CircularProgress } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import SearchField from '../inputs/SearchField';
import RxOrderContainer from "../../containers/RxOrder";
import CommonContainer from "../../containers/Common";
import RxOrderRowForm from '../forms/RxOrderRowForm';
import RxOrderRowNewForm from '../forms/RxOrderRowNewForm';
import { RxOrder } from 'openapi';
import RxOrderRowText from '../forms/RxOrderRowText';
import ReloadButton from '../buttons/ReloadButton';

interface Props {
    date: Date,
    rxOrders: RxOrder[],
    isLoading: boolean,
    onSelectedDateChange: (date: Date | null) => void,
    onOrder: (rxOrder: RxOrder) => void,
    onReload: () => void,
}

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

const useStyles = makeStyles((theme: Theme) => createStyles({
    table: {
        minWidth: 650,
    },
}));

export default ((props) => {
    const classes = useStyles({});
    const rxOrderContainer = RxOrderContainer.useContainer();
    const commonContainer = CommonContainer.useContainer();
    const [filterString, setFilterString] = useState('');

    const handleAddRow = () => {
        rxOrderContainer.setSelectedOrderId(-1);
        rxOrderContainer.setIsNewRow(rxOrderContainer.isNewRow ? false : true);
    }

    const searchFilter = (filterString: string) => {
        setFilterString(filterString);
    }

    return (
        <>
            <TableContainer component={Paper}>
                <ThemeProvider theme={theme}>
                    <Box m={3} bgcolor="background.paper">
                        <Grid container justify="center" className="cardContainer">
                            <Grid item xs>
                                <Typography variant="h6">Rx Order</Typography>
                            </Grid>
                            <Grid item xs={8} lg={5}></Grid>
                            <Grid item xs>
                                <SearchField onClick={handleAddRow} searchFilter={searchFilter} />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box m={3} bgcolor="background.paper">
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                        >
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Recorded Date"
                                    format="yyyy/MM/dd"
                                    value={props.date}
                                    onChange={props.onSelectedDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                            <div>
                                <ReloadButton onReload={props.onReload} />
                            </div>
                        </Grid>
                    </Box>
                </ThemeProvider>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {props.isLoading ?
                        <Box p={10}>
                            <CircularProgress size={50} thickness={2} />
                            <Typography variant="subtitle2">
                                No records to display
                            </Typography>
                        </Box>
                        :
                        rxOrderContainer.rxOrders.length > 0 || rxOrderContainer.isNewRow ?
                            <></>
                            :
                            <Box p={10}>
                                <Typography variant="subtitle2">
                                    No records to display
                                </Typography>
                            </Box>
                    }
                </div>
                <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                        {rxOrderContainer.rxOrders.map((rxOrder, index) => {

                            // For Search
                            const leftlens = commonContainer.getLens(rxOrder.leftMeganetLensMasterId);
                            const rightlens = commonContainer.getLens(rxOrder.rightMeganetLensMasterId);

                            if (rxOrder.meganetLensRxOrderId.toString().includes(filterString) || (leftlens ? leftlens.lensName.includes(filterString) : false) || (rightlens ? rightlens.lensName.includes(filterString) : false)) {

                                if (rxOrderContainer.isEditing) {
                                    if (rxOrderContainer.selectedOrderId === rxOrder.meganetLensRxOrderId && rxOrder.meganetLensRxOrderId.toString().includes(filterString)) {
                                        return <RxOrderRowForm key={index} rowData={rxOrder} date={props.date} />
                                    }
                                }
                                return <RxOrderRowText key={index} isLoading={props.isLoading} rowData={rxOrder} onOrder={props.onOrder} />

                            }
                        })}
                        {rxOrderContainer.isNewRow && <RxOrderRowNewForm key='-1' date={props.date} />}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}) as React.FC<Props>
